import { Link, useLocation } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { mergeQueryString } from 'bernie-core';

import { LodgingPwaPropertySearch, SearchDialogMessage, SearchLinkMessage } from '__generated__/api/types';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkText } from 'uitk-react-text';

import { LegalDialog } from './legal-dialog';

const LinkTracked = ClickTracker(Link);
const ATracked = ClickTracker('a');

export type HeaderMessageLinkProps = {
  linkName?: string;
} & LodgingPwaPropertySearch.ResultsSummary &
  Omit<SearchLinkMessage.Fragment, '__typename'> &
  Omit<SearchDialogMessage.Fragment, '__typename'>;

export const HeaderMessageLink: React.FunctionComponent<HeaderMessageLinkProps> = ({
  icon,
  link,
  label,
  linkName,
  value,
  dialogTrigger,
}) => {
  const location = useLocation();

  return (
    <>
      {dialogTrigger ? (
        <>
          <UitkMoreInfoTrigger type={200}>
            <LinkTracked
              to={`${location.pathname}?${mergeQueryString(location.search, { pwaDialog: dialogTrigger.dialogName })}`}
              linkName={value}
              rfrr={dialogTrigger.referrerId}
            >
              <UitkText weight="bold">{value}</UitkText>
              {icon && <UitkIcon name={icon.id} title={label} id={icon.id} />}
            </LinkTracked>
          </UitkMoreInfoTrigger>

          <LegalDialog dialogName={dialogTrigger.dialogName} {...dialogTrigger.actionDetails} />
        </>
      ) : (
        <UitkMoreInfoTrigger type={200}>
          <ATracked href={link.url} linkName={linkName || value} rfrr={link.referrerId} target="_blank" rel="noopener">
            <UitkText weight="bold">{value}</UitkText>
            {icon && <UitkIcon name={icon.id} title={label} id={icon.id} />}
          </ATracked>
        </UitkMoreInfoTrigger>
      )}
    </>
  );
};

HeaderMessageLink.displayName = 'HeaderMessageLink';
